import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Riders from './Riders';
import Drivers from './Drivers';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import UserPermissions from './UserPermissions';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeStyles} from '@mui/styles';
import { FONT_FAMILY, labelText } from "../common/sharedFunctions"
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Typography } from '@mui/material';
import { PageHeader, SurfaceCard } from "../components/adminPrimitives";
import adminTokens from "../styles/adminDesignTokens";

  const useStyles = makeStyles({
  tabs: {

    "& .MuiTabs-indicator": {
      backgroundColor: adminTokens.colors.garahexOrange,
      height: 4,
      borderRadius: 999,
    },
    "& .MuiTab-root.Mui-selected": {
      color: adminTokens.colors.deepNavy
    },
    "& .MuiTab-root": {
      minHeight: 52,
      borderRadius: 14,
      textTransform: "none",
    }
  },
  typography:{
    fontFamily:FONT_FAMILY,
    fontWeight: 850
  }
})
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = React.useState(null);
  const classes = useStyles();
  const label = (key, fallback) => labelText(t, key, fallback);

  React.useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleChange = (event, newValue) => {
    navigate(`/users/${newValue}`)
  };

  React.useEffect(()=>{
    if (!role) return;
    const tabIndex = Number(id);
    const maxTabIndex = role === "admin" ? 4 : 1;
    if(id && Number.isInteger(tabIndex) && tabIndex >= 0 && tabIndex <= maxTabIndex){
      setValue(tabIndex);
    }else{
      navigate("/users/0");
    }
  },[id,navigate, role])

  return (
    <Box sx={{ width: '100%' }}>
      <PageHeader
        eyebrow={label("account_management", "Account Management")}
        title={label("clients_fleet_management", "Clients & Fleet Management")}
        description={label("clients_fleet_management_description", "Manage client, driver, fleet admin, vehicle, and access records using the existing Garahex account workflows.")}
      />
      <SurfaceCard sx={{ mb: 2, p: 1 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"  className={classes.tabs} variant="scrollable">
          <Tab label={ <Typography className={classes.typography}>{t('riders')}</Typography>} {...a11yProps(0)} />
          <Tab  label={ <Typography className={classes.typography}>{t('drivers')}</Typography>} {...a11yProps(1)} />
          {role === 'fleetadmin'?
            null : <Tab  label={ <Typography className={classes.typography}>{label('fleet_admins_logistics', 'Fleet Admins / Logistics Companies')}</Typography>} {...a11yProps(2)} />
          }
          {role === 'fleetadmin'?
            null : <Tab label={ <Typography className={classes.typography}>{t('alladmin')}</Typography>} {...a11yProps(3)} />
          }
          {role === 'admin'?
            <Tab label={ <Typography className={classes.typography}>{label('roles_permissions_users_access', 'Roles, Permissions, Users & Access')}</Typography>} {...a11yProps(4)} />
            : null
          }
        </Tabs>
      </SurfaceCard>
      <TabPanel value={value} index={0}>
        <Riders/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Drivers/>
      </TabPanel>
      {role === 'admin'?
        <>
          <TabPanel value={value} index={2}>
            <FleetAdmins/>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <CreateAdmin/>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <UserPermissions/>
          </TabPanel>
        </>
      : null}
    </Box>
  );
}
